@if (_active) {
  <kendo-window (close)="_closeForm()" title="Add New Record" (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm reportForm">
    <form [formGroup]="editForm" (keydown.enter)="$event.preventDefault()">
      <div class="row addNewForecastForm">
        <!-- <div class="col-12">
        <div class="bordered_sections">
          <div class="col-12 import_title">Follow the Steps</div>
          <kendo-stepper [steps]="_steps" [stepType]="'full'" [(currentStep)]="currentStep" [linear]="false">
          </kendo-stepper>
        </div>
      </div> -->
      <div class="col-12">
        <div class="row stepsRowMargin">
          <div class="col-12 col-lg-6 stepsColPadding">
            <div class="row stepsRowMargin">
              <div class="col-12 stepsColPadding">
                <div class="row">
                  <div class="col-12">
                    <p class="step_title">Report Info</p>
                  </div>
                  <div class="col-12">
                    <div class="bordered_sections_special min-height-section"
                      [class.active-step-report]="currentStep === 0">
                      <!--All Sites DropDown-->
                      <div class="row">
                        <div class="col-12">
                          <!--All Sites DropDown-->
                          <sites-dropdown #kendo_combo_SiteCode [(ngModel)]="_siteSelected"
                            (siteChanged)="_handleSitesChange($event)" [ngModelOptions]="{standalone: true}"
                            [textField]="'code'" [valueField]="'id'" [showAllSites]="true"
                            class="MultiSiteCustomComboBox bordered fullavailableWidth"
                            [layout]="'form-group'"
                            [labelText]="'Site Code'">
                          </sites-dropdown>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label class="control-label trl" for="reportName">
                              Report name
                            </label>
                            <input #kendo_input_Report_Name type="text" class="k-textbox writebox fullavailableWidth"
                              formControlName="reportName" placeholder="Enter Report Name"
                              (keyup.enter)="_ReportNameChange()" (keydown.Tab)="_ReportNameChange()" required />
                            </div>
                            <div class="form-group">
                              <label class="control-label trl" for="reportCategory">
                                Report Category
                              </label>
                              <kendo-combobox #kendo_combo_Report_Category [data]="categories"
                                (valueChange)="GetFieldsByCategory($event)" class="bordered fullavailableWidth"
                                [textField]="'reportCategoryname'" [valueField]="'reportCategoryid'"
                                [valuePrimitive]="true" placeholder="Select Category" formControlName="reportCategoryid">
                              </kendo-combobox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special min-height-section skipsectionpadding"
                        [class.active-step-report]="currentStep === 1">
                        <div class="skipSpan" [class.skipButtonView]="currentStep === 1" (click)="_skipStepOrientation()">
                          skip
                          <span>
                            <img class="skipimage" [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                          </span>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <input type="checkbox" formControlName="addLogo" id="addLogo" class="k-checkbox"
                                (change)="getLogoChange()" kendoCheckBox />
                                <label class="k-checkbox-label trl" for="addLogo">
                                  Include Logo
                                </label>
                              </div>
                              <div class="form-group">
                                <input type="checkbox" formControlName="addAddress" id="addAddress" class="k-checkbox"
                                  (change)="includeAddressChange()" kendoCheckBox />
                                  <label class="k-checkbox-label trl" for="addAddress">
                                    Include Address
                                  </label>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="row">
                                  <div class="col-12">
                                    <label class="control-label trl" for="orientation">Orientation</label>
                                    <kendo-combobox #kendo_Combo_Orientation [data]="OrientationData" [suggest]="true"
                                      class="fullavailableWidth" formControlName="orientation"
                                      (valueChange)="orientationChange()">
                                    </kendo-combobox>
                                    <!-- <input type="radio" name="orientation" value="Portrait"
                                    formControlName="orientation" kendoRadioButton />
                                    <label class="k-radio-label reportRadioLabel"
                                    [for]="orientation">Portrait</label> -->
                                  </div>
                                  <!-- <div class="col-12">
                                  <label class="control-label trl"
                                  [for]="orientation"></label>
                                  <input type="radio" name="orientation" value="Landscape"
                                    formControlName="orientation" kendoRadioButton />
                                    <label class="k-radio-label reportRadioLabel"
                                    [for]="orientation">Landscape</label>
                                  </div> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row stepsRowMargin">
                    <div class="col-12 col-md-7 stepsColPadding">
                      <div class="row">
                        <div class="col-12">
                          @if (fields) {
                            <asap-fields-select-from-boxes class="select-boxes" [fields]="fields"
                              [selectedFields]="selectedFields" (selectedFieldsOutput)="_onchangeSelectedFields($event)"
                              [displayFieldName]="'title'" [title]="'Fields'" [fullWidth]="true" [max10Items]="true"
                              [showFilters]="false" [withPrimary]="false">
                            </asap-fields-select-from-boxes>
                          }
                        </div>
                        <!-- <div class="col-12">
                        <p class="step_title">Select Fields</p>
                      </div>
                      <div class="col-12">
                        <div class="row stepsRowMargin">
                          <div class="col-6 stepsColPadding">
                            <div class="bordered_sections_special_small_listbox bordered_sections_special_left minHeightSection leftListbox"
                              [class.active-step-report]="currentStep === 2">
                              <div class="buttonsAbsolutecontainer_left"
                                [class.disabled]="!fields || fields.length == 0">
                                <img (click)="moveSelected('right')"
                                  [src]="'/assets/menu/'+ _theme +'/move-right-arrow.svg'" />
                                  <img (click)="moveAll('right')"
                                    [src]="'/assets/menu/'+ _theme +'/move-all-right-arrow.svg'" />
                                  </div>
                                  <div class="row">
                                    <div class="col-12">
                                      <ul class="selectedFieldsArray">
                                        <li *ngFor="let field of fields; index as i;"
                                          (click)="toggleSelection(i, 0)"
                                          [class.item-selected]="field.isSelected">
                                          <span>{{field.title}}</span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 stepsColPadding">
                                <div class="bordered_sections_special_small_listbox minHeightSection rightListbox"
                                  [class.active-step-report]="currentStep === 2">
                                  <div class="buttonsAbsolutecontainer_right"
                                    [class.disabled]="!selectedFields || selectedFields.length == 0">
                                    <img (click)="moveSelected('left')"
                                      [src]="'/assets/menu/'+ _theme +'/move-left-arrow.svg'" />
                                      <img (click)="moveAll('left')"
                                        [src]="'/assets/menu/'+ _theme +'/move-all-left-arrow.svg'" />
                                        <img (click)="verticalMove('down')"
                                          [src]="'/assets/menu/'+ _theme +'/move-down-arrow.svg'" />
                                          <img (click)="verticalMove('up')"
                                            [src]="'/assets/menu/'+ _theme +'/move-up-arrow.svg'" />
                                          </div>
                                          <div class="row">
                                            <div class="col-12">
                                              <ul class="selectedFieldsArray">
                                                <li *ngFor="let field of selectedFields; index as i;"
                                                  (click)="toggleSelection(i, 1)"
                                                  [class.item-selected]="field.isSelected">
                                                  <span>{{field.title}}</span>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                                </div>
                              </div>
                              <div class="col-12 col-md-5 stepsColPadding">
                                <div class="row">
                                  <div class="col-12">
                                    <p class="step_title">
                                      Select Groups<span class="stepDescription">(Optional)</span>
                                    </p>
                                  </div>
                                  <div class="col-12">
                                    <div class="bordered_sections_special_small minHeightSection"
                                      [class.active-step-report]="currentStep === 3">
                                      <div class="skipSpan" [class.skipButtonView]="currentStep === 3" (click)="_skipStep()">
                                        skip
                                        <span>
                                          <img class="skipimage" [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                                        </span>
                                      </div>
                                      <div class="row">
                                        <div class="col-12">
                                          <div class="form-group">
                                            <label class="control-label trl sgcb" for="groupBy">Group By</label>
                                            <kendo-combobox #kendo_combo_groupby [data]="selectedFields" [textField]="'title'"
                                              formControlName="groupBy" [valueField]="'field'"
                                              (selectionChange)="selectGroupHeader($event)" class="reportCombobox_sgcb" placeholder="">
                                            </kendo-combobox>
                                          </div>
                                          <div class="form-group">
                                            <label class="control-label trl sgcb left" for="groupHeader">Group Header</label>
                                            <div #kendo_multiselect_wrapper class="customMultiSelectList customMultiSelectListReports">
                                              <kendo-multiselect [summaryTagAfter]="0" #kendo_multiselect
                                                class="customMultiSelect" formControlName="groupHeader" placeholder="Select Header"
                                                [autoClose]="false" [(ngModel)]="_selectedGroupHeaders"
                                                (valueChange)="_groupheaderChange($event)" (document:click)="_multiSelectClose($event)"
                                                [itemDisabled]="_itemDisabled" [data]="selectedFields" textField="title"
                                                valueField="field">
                                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                                  <input type="checkbox" class="k-checkbox" [checked]="_isItemSelected(dataItem.id)">
                                                  <label class="k-checkbox-label">
                                                    {{
                                                    dataItem.title
                                                    }}
                                                  </label>
                                                </ng-template>
                                              </kendo-multiselect>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-6 stepsColPadding">
                            <div class="row stepsRowMargin">
                              <div class="col-12 stepsColPadding">
                                <div class="row">
                                  <div class="col-12">
                                    <p class="step_title">Report Preview</p>
                                  </div>
                                  <div class="col-12">
                                    <div class="bordered_sections_special_right fullminHeightSection"
                                      [class.active-step-report]="currentStep === 4">
                                      <!-- <div *ngIf="currentStep !== 4" class="report-overlay"></div> -->
                                      <div class="row rowcenteredDisplay">
                                        <div class="col-12">
                                          <div class="reportImageContainer">
                                            @if (previewReport) {
                                              <report-viewer [reportObject]="previewReportObj"
                                                [definitionOnly]="definitionOnly" [reportParent]="'custom'"
                                                (returnDefinition)="saveReportDefinition($event)">
                                              </report-viewer>
                                            }
                                            @if (!previewReport) {
                                              <img class="reportDefaultImg"
                                                [src]="'/assets/menu/'+ _theme +'/report-image.svg'" />
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    @if (_invalidForm) {
                      <asap-forms-validation-summary [form]="_currentForm" [page]="'customReport'"
                        [listToValidate]="selectedFields">
                      </asap-forms-validation-summary>
                    }
                    <div class="row">
                      <div class="col-12" style="margin-top:10px">
                        @if (currentStep >= 3 || (selectedFields && selectedFields.length > 0)) {
                          <button kendoButton class="steps_buttons_class"
                            (click)="save('close')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save and close</span>
                          </button>
                        }
                        @if (currentStep >= 3 || (selectedFields && selectedFields.length > 0)) {
                          <button kendoButton class="steps_buttons_class"
                            (click)="save('edit')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save and edit</span>
                          </button>
                        }
                        @if (currentStep >= 3 || (selectedFields && selectedFields.length > 0)) {
                          <button kendoButton class="steps_buttons_class"
                            (click)="save('process')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save and process</span>
                          </button>
                        }
                        @if (currentStep < 4) {
                          <button kendoButton class="steps_buttons_class" (click)="nextStep()">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/next-icon.svg'" />
                            <span>Next</span>
                          </button>
                        }
                        @if (currentStep > 0) {
                          <button kendoButton class="steps_buttons_class" (click)="previousStep()">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/back-icon.svg'" />
                            <span>Back</span>
                          </button>
                        }
                      </div>
                    </div>
                  </form>
                </kendo-window>
              }
